import { Snackbar } from '@mui/material'
import { Alert } from '@mui/material'

type Color = 'success' | 'info' | 'warning' | 'error'
interface Props {
  open: boolean
  onClose: () => any
  msg: string
  severity?: Color
}

export const AlertSnackbar: React.FC<Props> = ({ open, onClose, msg, severity = 'success' }) => {
  return (
    <Snackbar open={open} autoHideDuration={5000} onClose={onClose}>
      <Alert elevation={6} variant="filled" severity={severity as Color}>
        {msg}
      </Alert>
    </Snackbar>
  )
}
